/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Reviewer_DescInputs */

const en_mk_team_reviewer_desc = /** @type {(inputs: Mk_Team_Reviewer_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A second agent reads the merged result without changing a single file, then records findings by severity. Serious findings hold the merge until they are fixed. Review allowance follows your plan.`)
};

const id_mk_team_reviewer_desc = /** @type {(inputs: Mk_Team_Reviewer_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent kedua membaca hasil gabungan tanpa mengubah satu berkas pun, lalu mencatat temuan per tingkat. Temuan berat menahan penggabungan sampai diperbaiki. Jatah pemeriksaan mengikuti paketmu.`)
};

/**
* | output |
* | --- |
* | "A second agent reads the merged result without changing a single file, then records findings by severity. Serious findings hold the merge until they are fixe..." |
*
* @param {Mk_Team_Reviewer_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_reviewer_desc = /** @type {((inputs?: Mk_Team_Reviewer_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Reviewer_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_reviewer_desc(inputs)
	return en_mk_team_reviewer_desc(inputs)
});